import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "../../redux/slice/Slice";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../../redux/saga";
let sagamiddleware = createSagaMiddleware();
const middleware = [sagamiddleware];
const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  auth: authSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(middleware)
  }
});
sagamiddleware.run(rootSaga);
const persistor = persistStore(store);

export { store, persistor };
